export class Progetti {
    progetto:any;
    code:any;
    description:any;
    active:any;
    id:any;
} 
